import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, TableCell, TableRow } from '@mui/material';
import CollapsedProductsTable from './CollapsedProductsTable';
import { CalendarMonth, Discount } from '@mui/icons-material';

const formatPrice = (value) => {
  if (value === undefined || value === null) return 'Q -';
  const num = typeof value === 'number' ? value : parseFloat(value);
  return isNaN(num) ? 'Q -' : `Q ${num.toFixed(2)}`;
};
const columns = [
  { key: 'code', label: 'Código' },
  { key: 'description', label: 'Descripción' },
  { key: 'quantity', label: 'Cantidad', align: 'right' },
  {
    key: 'prformat',
    label: 'Formato',
    align: 'right',
    render: (row) => {
      const v = row?.prformat;
      if (v && typeof v === 'object') return v.name || '—';
      return v || '—';
    }
  },
  {
    key: 'listPrice',
    label: 'Precio Lista',
    align: 'right',
    render: (row) => formatPrice(row.listPrice),
  },
  {
    key: 'finalPrice',
    label: 'Precio Final',
    align: 'right',
    render: (row) => formatPrice(row.finalPrice),
  },
];


export default function OrderSummary({ order, orderDetails, orderBonus }) {

  const [expanded, setExpanded] = React.useState(false);
// Función de ayuda para formatear la fecha
const formatDateTime = (isoString) => {
    const date = new Date(isoString);
    if (isNaN(date)) return "Fecha Inválida";

    // Opciones para el formato de fecha y hora
    const dateFormat = new Intl.DateTimeFormat('es-GT', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(date);

    const timeFormat = new Intl.DateTimeFormat('es-GT', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true, // Usa AM/PM
    }).format(date);

    return {
        date: dateFormat, // Ej: 14/11/2025
        time: timeFormat, // Ej: 12:00 PM
    };
};

const formattedDate = formatDateTime(order.dateTime);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const renderExtras = (row) => {
    return orderBonus
      ?.filter(bonus => bonus.source_product_id === row.product_id)
      .map((bonus, idx) => (
        <TableRow
          key={`bonus-${idx}`}
          sx={{
            backgroundColor: '#f5f5f5',
            '& td': { py: '4px', fontSize: '0.8rem' },
          }}
        >
          <TableCell />
          <TableCell colSpan={2}>
            <Box display="flex" alignItems="center">
              <Discount color="success" fontSize="small" sx={{ mr: 1 }} />
              {bonus.description || 'Producto promocional'}
            </Box>
          </TableCell>
          <TableCell align="right">{bonus.quantity}</TableCell>
          <TableCell align="right">{(bonus?.prformat && typeof bonus.prformat === 'object') ? (bonus.prformat.name || '—') : (bonus?.prformat || '—')}</TableCell>
          <TableCell align="right">-</TableCell>
          <TableCell align="right">-</TableCell>
        </TableRow>
      ));
  };

  return (
<div>
    {/* Nuevo diseño de la fecha con iconos */}
    <Box
        sx={{
            display: 'flex',
            alignItems: 'center',
            p: 1, // Padding
            mt: 1,
            mx: 0.5, // Margin X (para alinearse con el resto del contenido)
            borderRadius: 1,
            // Fondo suave para resaltar, usando un color primario o un gris claro
            backgroundColor: (theme) => theme.palette.mode === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
            borderLeft: '4px solid #9c1a15', // Borde vertical para un toque de color
        }}
    >
        <Typography variant='subtitle1' sx={{fontWeight:500, fontSize:16, mr: 2, color: 'text.secondary' }}>
            Entrega:
        </Typography>

        {/* Fecha */}
        <CalendarMonth sx={{ color: '#9c1a15', mr: 1, fontSize: '1.2rem' }} />
        <Typography variant='body1' sx={{ mr: 2, fontWeight: 500 }}>
            {formattedDate.date}
        </Typography>
    </Box>
      <Accordion
        expanded={expanded === 'panel1'}
        sx={{
          marginTop: '10px',
          marginLeft: '5px',
          marginBottom: '20px',
          backgroundColor: '#EDEDED'
        }}
        onChange={handleChange('panel1')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography component="span" sx={{ width: '33%', flexShrink: 2, fontWeight: 'bold' }}>
            Resumen de productos
          </Typography>
          <Typography sx={{ color: 'text.primary' }}>
            Total: {new Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(order.total)}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <CollapsedProductsTable
            data={orderDetails}
            columns={columns}
            renderExtras={renderExtras}
          />
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
